__webpack_require__.p = "/ngrx-actions-custom-scope/referrals-hub/";